import ChannelFormMarketplace from './ChannelFormMarketplace'

export default ChannelFormMarketplace
